export default __webpack_public_path__ + "static/animated-product-6d5cd6b342abec9954633f5f082c74e6.mp4";